import styled from "styled-components";
import {RowDiv} from "./RowDiv";

export const TableTitleDiv = styled(RowDiv)`
  height: 48px;
  justify-content: space-between;
`